export default __webpack_public_path__ + "static/media/SorocabaMobile.7ca712b8.png";